import { ArrowRight } from 'lucide-react'
import { Icon } from './ui/icon'

interface CallToActionProps {
  icon: string
  title: string
  body: string
  onClick: () => void
}

export function CallToAction({ icon, title, body, onClick }: CallToActionProps) {
  return (
    <div className="ad-cta-card" onClick={onClick}>
      <div className="ad-cta-card__icon">
        <Icon name={icon} className="size-5" />
      </div>
      <div className="ad-cta-card__content">
        <div className="ad-cta-card__title">{title}</div>
        <div className="ad-cta-card__body">{body}</div>
      </div>
      <ArrowRight className="size-4 ad-cta-card__arrow" />
    </div>
  )
}
